import React from 'react';
import { Tooltip } from 'antd';
const css = require('./index.scss');

interface Iprops {
    title: string;
    children: React.ReactNode;
    drag: any;
}
export default function Tip(props: Iprops) {
    const [visibile, setVisible] = React.useState(false);
    
    return (
        <span
            ref={props.drag}
            onClick={(e)=> e.stopPropagation()}
            onMouseDown={(e) => setVisible(false)}
            onMouseUp={(e) => setVisible(true)}
            onMouseLeave={(e) => setVisible(false)}
            onMouseEnter={(e) => setVisible(true)}
            className={css.dragtip}
        >
            <Tooltip title={props.title} visible={visibile} getPopupContainer={triggerNode => triggerNode} mouseLeaveDelay={0}>
                {props.children}
            </Tooltip>
        </span>);
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench2/UI.MenuNew/DragTip.tsx